<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">CONTENTS</h1>
<div class="SOM_pre"><a href="#/pre2">Foreword to the Signature Edition by Mark Mittelberg</a></div>
<div class="SOM_pre"><a href="#/pre3">Introduction to the Second Edition</a></div>
<div class="SOM_chap"><a href="#/chap1">1 SLEEPLESS IN SPAIN</a></div>
<div class="SOM_chap"><a href="#/chap2">2 JESUS—THE MOST HUMAN OF US ALL</a></div>
<div class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample">3 JESUS—THE LORD OF ALL</span></div>
<div class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample">4 A QUESTION OF LOVE: <i>Being Radically Identified with the World</i></span></div>
<div class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample">5 A QUESTION OF HOLINESS: <i>Being Radically Different from the World</i></span></div>
<div class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample">6 A QUESTION OF OBEDIENCE: <i>Another Way of Knowing God</i></span></div>
<div class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample">7 CHRIST WITH US</span></div>
<div class="SOM_chap"><span href="#/chap8" title="Link target outside of Sample">8 PRACTICING THE PRESENCE OF CHRIST</span></div>
<div class="SOM_chap"><span href="#/chap9" title="Link target outside of Sample">9 DEVELOPING CONVERSATIONAL SKILLS</span></div>
<div class="SOM_chap"><span href="#/chap10" title="Link target outside of Sample">10 THREE WAYS TO WITNESS</span></div>
<div class="SOM_chap"><span href="#/chap11" title="Link target outside of Sample">11 CULTIVATING THE SOIL</span></div>
<div class="SOM_chap"><span href="#/chap12" title="Link target outside of Sample">12 PLANTING THE SEED</span></div>
<div class="SOM_chap"><span href="#/chap13" title="Link target outside of Sample">13 REAPING THE HARVEST IN GOD’S TRUTH AND LOVE</span></div>
<div class="SOM_chap"><span href="#/chap14" title="Link target outside of Sample">14 REAPING THE HARVEST IN GOD’S POWER</span></div>
<div class="SOM_chap"><span href="#/chap15" title="Link target outside of Sample">15 REVEALING TRUTH THROUGH REASON</span></div>
<div class="SOM_chap"><span href="#/chap16" title="Link target outside of Sample">16 REVEALING TRUTH THROUGH STORIES</span></div>
<div class="SOM_chap"><span href="#/chap17" title="Link target outside of Sample">17 REVEALING TRUTH THROUGH THE POWER OF THE SPIRIT</span></div>
<div class="SOM_chap"><span href="#/chap18" title="Link target outside of Sample">18 THE WITNESS OF COMMUNITY</span></div>
<div class="SOM_chap"><span href="#/chap19" title="Link target outside of Sample">19 WITHOUT A VISION THE PEOPLE WILL PERISH</span></div>
<div class="SOM_chap"><span href="#/appen4" title="Link target outside of Sample">APPENDIX 1: <i>Gospel Outlines</i></span></div>
<div class="SOM_chap"><span href="#/appen5" title="Link target outside of Sample">APPENDIX 2: <i>Books for Evangelism</i></span></div>
<div class="SOM_chap"><span href="#/appen6" title="Link target outside of Sample">APPENDIX 3: <i>Study Guide for Individuals or Groups</i></span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen10" title="Link target outside of Sample">Praise for <i>Out of the Saltshaker and Into the World</i></span></div>
<div class="SOM_appen"><span href="#/appen11" title="Link target outside of Sample">About the Author</span></div> <div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">IVP Signature Collection</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?c69b8776